export default __webpack_public_path__ + "static/media/tfa.60f9fd89.svg";